import { getAreasOfNeed, populatePlaceholderText } from '@/api/presentlevels.js'

export function buildIODStatement({impactAreaStatements, subjectStatements, selectedDisability, selectedSubjects, selectedImpactAreas}) {
  let allStatementsForDisability = subjectStatements[selectedDisability]
  let statement = '';
  let isStatementEmptyPlaceholder = false;
  const hasSelectedImpactAreas = selectedImpactAreas.length > 0 && impactAreaStatements.length > 1
  const disabilityHasSingleImpactArea = impactAreaStatements.length <= 1
  const includeImpactAreaStatements = hasSelectedImpactAreas || disabilityHasSingleImpactArea
  const hasSelectedSubjects = selectedSubjects.length > 0
  if (includeImpactAreaStatements) {
    if (disabilityHasSingleImpactArea) {
      selectedImpactAreas = impactAreaStatements;
    }
    statement = compileImpactStatements(selectedImpactAreas, selectedSubjects, allStatementsForDisability)
    isStatementEmptyPlaceholder = false
  } else {
    if (hasSelectedSubjects) {
      statement = '[Select an impacted area to compose a statement.]'
      isStatementEmptyPlaceholder = true
    } else {
      statement = '[Select a subject and an impacted area to compose a statement.]'
      isStatementEmptyPlaceholder = true
    }
  }
  return [populatePlaceholderText(statement, {
    studentName: '(student)',
  }), isStatementEmptyPlaceholder];
}

// Beta-mode statement builder that works directly with LLM-generated
// statements instead of Airtable impact area intros.
//
// Expects statementsForDisability to be an array of objects with:
// { subject, area_uuid, statement_text }
export function buildBetaIODStatement({ statementsForDisability, selectedSubjects, selectedImpactAreas }) {
  const hasSelectedSubjects = selectedSubjects && selectedSubjects.length > 0
  const hasSelectedImpactAreas = selectedImpactAreas && selectedImpactAreas.length > 0

  let statement = ''
  let isStatementEmptyPlaceholder = false

  if (!hasSelectedImpactAreas) {
    const hasLLMStatements = (statementsForDisability || []).length > 0

    // If there are no impact areas configured but we DO have statements for the selected subjects
    if (hasSelectedSubjects && hasLLMStatements) {
      const filteredBySubject = statementsForDisability.filter(s =>
        selectedSubjects.includes(s.subject)
      )

      statement = filteredBySubject.map(s => s.statement_text).join(' \n\n')
      return [populatePlaceholderText(statement, { studentName: '(student)' }), isStatementEmptyPlaceholder]
    }

    if (hasSelectedSubjects && !hasLLMStatements) {
      statement = '[Select an impacted area to compose a statement.]'
    } else if (!hasSelectedSubjects) {
      statement = '[Select a subject and an impacted area to compose a statement.]'
    }
    isStatementEmptyPlaceholder = true
    return [populatePlaceholderText(statement, { studentName: '(student)' }), isStatementEmptyPlaceholder]
  }

  if (!hasSelectedSubjects) {
    statement = '[Select a subject and an impacted area to compose a statement.]'
    isStatementEmptyPlaceholder = true
    return [populatePlaceholderText(statement, { studentName: '(student)' }), isStatementEmptyPlaceholder]
  }

  const selectedAreaUUIDs = selectedImpactAreas.map(ia => ia.area_uuid)

  const filteredStatements = (statementsForDisability || []).filter(s => {
    return selectedSubjects.includes(s.subject) && selectedAreaUUIDs.includes(s.area_uuid)
  })

  statement = filteredStatements.map(s => s.statement_text).join(' \n\n')

  return [populatePlaceholderText(statement, { studentName: '(student)' }), isStatementEmptyPlaceholder]
}

function compileImpactStatements(selectedImpactAreas, selectedSubjects, allStatementsForDisability) {
  const hasSelectedSubjects = selectedSubjects.length > 0
  selectedImpactAreas.sort((a,b) => parseInt(a.area_order) - parseInt(b.area_order))
  let statement = ''
  selectedImpactAreas.forEach((ia) => {
    statement += ia.area_statement_text
    statement += ' '

    if (hasSelectedSubjects) {
      let statementsForSubject = allStatementsForDisability.filter(s => selectedSubjects.includes(s.subject) && s.area_uuid === ia.area_uuid)
      const subjectsInOrder = getAreasOfNeed({iodSubject: true}).map(s => s.label)
      statementsForSubject.sort((a,b) => {
        const aIndex = subjectsInOrder.indexOf(a.subject)
        const bIndex = subjectsInOrder.indexOf(b.subject)
        return aIndex - bIndex;
      })
      statementsForSubject.forEach((subject) => {
        statement += subject.statement_text
        statement += ' '
      })
    } else {
      statement += '\n\n[Select a subject to complete the statement.]'
    }

    statement += '\n\n'
  })
  return statement
}